<template>
  <div class="team">
    <div
      v-show="!S_GlobalSearch && UserTeamInfo"
      style="padding-bottom: 50px;"
    >
      <audio
        v-if="soundData.testSound"
        ref="userExtensionsTestSound"
        :src="$handleAssetsUrl(soundData.testSound.url)"
        style="display: none;"
      ></audio>

      <div
        class="data-body"
        v-for="(item, index) in category"
        :key="item.id"
        :class="{'operation': dataArray[item.id].judge}"
        :style="{'height': dataArray[item.id].judge ? 'auto' : '140px' }"
      >
        <section
          class="my-bg"
          :class="{'fix-section-top': fixTopId.id === (item.id)}"
          :style="{
            'left': judgeFixed?  windowMove.left + 'px' : (windowMove.left + 280 + 'px'),
            'top':  windowMove.top + 'px',
          }"
          @click="
            getUserCategories({type: idsDict[item.id], share: 1, uiType: item.id}, $event);
            scrollTop(index);
            thisGetUserData(item.id);
            switchDataBoxAction(item.id);
          "
        >
          <el-tooltip
            effect="dark"
            content="点击可展开/收起"
            placement="left"
            :open-delay="1000"
          >
            <img
              :src="item.iconUrl"
              width="auto"
              height="100%"
            />
          </el-tooltip>
          <span v-if="item.id == 'video'">
            {{item.name}}(60s以内)
            <el-tooltip
              effect="dark"
              placement="top"
              :offset="-10"
            >
              <span slot="content">
                为保证导出效果,仅支持添加时长小于
                <br />60s的视频,其余视频将不在此处展示。
              </span>
              <span class="info-trigger">i</span>
            </el-tooltip>
          </span>
          <span v-else>{{item.name}}</span>
        </section>

        <div
          class="switchData"
          :class="{
            'fix-section-top': fixTopId.id === (item.id),
            'fix-switchData' : fixTopId.id != (item.id),
          }"
          :style="{
            'left': judgeFixed?  windowMove.left + 'px' : (windowMove.left + 280 + 'px'),
            'top':  windowMove.top + 'px',
          }"
          v-if="!personalCategory[item.id].switchJudge.judge"
        >{{personalCategory[item.id].switchJudge.msg}}</div>

        <div
          class="body-list"
          :style="{
            height: 'auto'
            // 'height': (dataArray[item.id].data.length? 'auto': '100px'),
            // --每个slide文件都会有注释这个css属性，禁止分组图固定在素材栏上方--
            // 'margin-top': fixTopId.id === (item.id) ? '120px' : '0px',
            // ----
          }"
        >
          <!-- <div v-if="!dataArray[item.id].data.length" class="add-bg" style="margin-bottom: 5px;">
            <div v-if="UserExtensions == 1">
              <a target="_black" href="/userCenter?userCenterTab=Accountsystem">
                <span class="uploadResource"></span>
                <span>上传并共享素材给子账号</span>
              </a>
            </div>
            <div v-if="UserExtensions == 2">
              <span>父账号还没有上传对应资源哦～</span>
            </div>
          </div>-->

          <!-- 分类菜单 -->
          <div
            class="menu-wrapper"
            v-if="item.id !== 'template' && cateOptions && cateOptions.length"
          >
            <DropDownMenu
              all="默认文件夹"
              :options="cateOptions"
              :selectedIndex="selectedCateIndex"
              :myStyle="{
                height: '38px',
                zIndex: 300, // 挡住方块
                uiType: item.id
              }"
              @clickItem="getDataByUserCate"
              ref="dropDownMenu"
            ></DropDownMenu>
          </div>

          <!--pic-->
          <div
            class="item itemImg"
            :class="{'haveCateOptions':cateOptions && cateOptions.length}"
            v-if="item.id === 'pic'"
            v-for="(itemL, indexL) in  dataArray[item.id].data"
            @mouseover="getCharacters($event, itemL);"
            @mouseout="closeCharacters();"
            @click="picItemClickFS(itemL)"
            :key="itemL.id"
          >
            <img
              :src="$handleAssetsUrl(itemL.thumbnailUrl)"
              @error="imgErroeFs( $event, itemL)"
              width="auto"
              height="100%"
            />
            <div class="maskItem"></div>
            <el-tooltip
              effect="dark"
              content="设置为背景"
              placement="bottom"
              :open-delay="1000"
              v-if="switchDataType == 0"
            >
              <span
                v-if="!( /\.gif$/.test(itemL.url) )"
                @mouseover="stopDocument($event)"
                @click.stop="
                  settingScenesBg(itemL);
                  materialPushAnalysis({type: 'imgSettingBg'});
                "
                class="modify modifyBg"
                style="
                  width: 30px;
                  height: 30px;
                  line-height: 20px;
                  left: 5px;
                  bottom: 5px;
                "
              ></span>
            </el-tooltip>
          </div>

          <!--video-->
          <div
            class="item itemImg"
            v-if="item.id === 'video'"
            :class="{'haveCateOptions':cateOptions && cateOptions.length}"
            v-for="(itemL, indexL) in  (dataArray[item.id].data || []).filter(v => (v.duration || v.times) < 60)"
            @mouseover="getCharacters($event, itemL);"
            @mouseout="closeCharacters();"
            @click="picItemClickFS(itemL, 'video')"
            :key="itemL.id"
          >
            <img
              :src="$handleAssetsUrl(itemL.thumbnailUrl)"
              width="auto"
              height="100%"
            />
            <span
              @mouseover="stopDocument($event)"
              class="label labelVideo el-icon-caret-right"
              style="
                right: 0;
                left: 5px;
                width: 18px;
                border-radius: 100%;
                background: #595574;
                z-index: 5;
              "
            ></span>
            <div class="maskItem"></div>

            <el-tooltip
              effect="dark"
              content="设置为背景"
              placement="bottom"
              :open-delay="1000"
              v-if="switchDataType == 0"
            >
              <span
                @mouseover="stopDocument($event)"
                @click.stop="
                  settingScenesBg(itemL);
                  materialPushAnalysis({type: 'imgSettingBg'});
                "
                class="modify modifyBg"
                style="
                  width: 30px;
                  height: 30px;
                  line-height: 20px;
                  left: 0px;
                  bottom: 0px;
                  border-radius: 0;
                "
              ></span>
            </el-tooltip>
          </div>

          <!-- sound -->
          <div v-if="item.id === 'music' || item.id === 'sound'">
            <NewSoundFeature></NewSoundFeature>
          </div>
          <!--audio tool-->
          <div
            class="itemAudio"
            v-if="item.id === 'music'"
            v-for="(itemL, indexL) in  dataArray[item.id].data"
            :key="itemL.id"
            :style="{backgroundColor: (soundData.toolSound.resourceId === itemL.id ? '#e7e7fb' : '')}"
          >
            <div class="playGrid">
              <el-tooltip
                effect="dark"
                content="试听"
                placement="bottom"
                :open-delay="1000"
              >
                <span
                  @click="testListenSound(itemL)"
                  :class="{
                    'stop' : soundData.playType && soundData.testSound.id === itemL.id ,
                    'play' : !soundData.playType || soundData.testSound.id != itemL.id ,
                  }"
                  style="margin: 0;"
                ></span>
              </el-tooltip>
            </div>
            <div class="detailGrid">
              <el-tooltip
                effect="dark"
                :content="itemL.title"
                placement="left"
                :open-delay="1000"
              >
                <p class="name">{{itemL.title}}</p>
              </el-tooltip>
              <p class="duration">{{resultFormat(itemL.duration)}}</p>
            </div>
            <div class="infoGrid">
              <div class="staticGrid">
                <div class="logoGrid">
                  <company
                    :itemData="itemL"
                    :boxName="boxName"
                  />
                </div>
              </div>

              <div class="selectedGrid">
                <el-tooltip
                  effect="dark"
                  content="使用"
                  placement="bottom"
                  :open-delay="1000"
                >
                  <el-popover
                    placement="right"
                    width="90"
                    trigger="hover"
                    close-delay="0"
                  >
                    <div class="set-sound-content">
                      <div @click="setMusic(itemL)">设置为背景音乐</div>
                      <div @click="setDub(itemL)">设置为全局旁白</div>
                      <div @click="setDubInScene(itemL)">设置为单页旁白</div>
                    </div>
                    <span
                      slot="reference"
                      :class="soundData.toolSound.resourceId === itemL.id ? 'select-active' : 'select'"
                    ></span>
                  </el-popover>
                </el-tooltip>
              </div>
            </div>
            <!-- <span
              v-if="manageMaterial.step == 2"
              class="manageMaterialMaskAudio"
              :class="{
                'manageMaterialMaskAction el-icon-check' : manageMaterial.dataArray[itemL.id],
              }"
              :style="{
                'border-color' : manageMaterial.dataArray[itemL.id] ? '#5175ff' : '#d8ddea',
              }"
              @click="manageMaterialStepFS(4, itemL, $event, item.id);"
            ></span>-->
          </div>

          <!--模版-->
          <div
            class="item itemImg"
            :class="{'haveCateOptions':cateOptions && cateOptions.length}"
            v-if="item.id === 'template'"
            v-for="(itemL, indexL) in  dataArray[item.id].data"
            @mouseover="
              getCharacters(
                $event,
                Object.assign({
                  fileType : 'template',
                  url      : itemL.videoUrl
                }, itemL)
              );
            "
            @mouseout="closeCharacters();"
            @click="addTemplate(itemL)"
            :key="itemL.id"
          >
            <img
              :src="$handleAssetsUrl(itemL.thumbnailUrl)"
              @error="imgErroeFs( $event, itemL)"
              width="auto"
              height="100%"
            />
            <div class="maskItem"></div>
          </div>

          <!-- 团队模板 -->
          <div
            class="item itemImg"
            v-if="item.id === 'teamTemplate'"
            :class="{'haveCateOptions':cateOptions && cateOptions.length}"
            v-for="(itemL, indexL) in  dataArray[item.id].data"
            @click="addTeamTemplateUserConfirm(itemL)"
            :key="itemL.id"
          >
            <img
              :src="$handleAssetsUrl(itemL.thumbnailUrl)"
              @error="imgErroeFs( $event, itemL)"
              width="auto"
              height="100%"
            />
            <div class="maskItem"></div>
          </div>

          <div
            class="item itemImg"
            v-if="item.id === 'logo'"
            v-for="(itemL, indexL) in  dataArray[item.id].data"
            @mouseover="getCharacters($event, {url: itemL.logoUrl, id: itemL.id});"
            @mouseout="closeCharacters();"
            @click="picItemClickFS(itemL, 'logo')"
            :key="itemL.id"
          >
            <img
              :src="$handleAssetsUrl(itemL.logoUrl)"
              @error="imgErroeFs( $event, itemL)"
              width="auto"
              height="100%"
            />
            <div class="maskItem"></div>
          </div>
          <!--loading-->
          <div
            v-loading="loading"
            v-if="loading"
            element-loading-background="rgba(0, 0, 0, 0)"
            element-loading-text="加载中..."
            element-loading-spinner="el-laihua-loading"
            style="width: 100%;height: 20px; margin-top: 47px;"
          ></div>
        </div>
      </div>

      <SwitchStyle />
      <CategoryPrompt
        v-show="slideState && dataMsg=='team'"
        v-model="fixTopId"
        :windowMove="windowMove"
        :judgeFixed="judgeFixed"
        :boxName="boxName"
        :dataArray="dataArray"
      />
    </div>

    <div v-show="S_GlobalSearch">
      <Search
        :boxName="boxName"
        :dataMsg="dataMsg"
        v-on:addsprite="settingScenesBg"
        :searchDataArray="dataArray"
        :loading="loading"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import rightnavSlide from "../../mixins/rightnavSlide";
import Search from "./search/search";
import domtoimage from "dom-to-image";
import Analysis from "../../mixins/analysis/materialBu";
import DropDownMenu from "../controls/menu";
import userCategoriesMixin from "./userCategoriesMixin";
import NewSoundFeature from '../newSoundFeature.vue';
import addSound from './addSound.js';

export default {
  mixins: [rightnavSlide, Analysis, userCategoriesMixin, addSound],
  data () {
    return {
      boxName: "team", // 素材盒子的名字
      personalCategory: {
        // 个人素材列表
        teamTemplate: {
          id: "teamTemplate",
          name: "团队模板",
          iconUrl: "/static/img/teamCategory.png",
          switchJudge: {
            judge: true,
            msg: ""
          }
        },
        template: {
          id: "template",
          name: "平台模板",
          iconUrl: "/static/img/myscenes0.jpg",
          switchJudge: {
            judge: true,
            msg: ""
          }
        },
        pic: {
          id: "pic",
          name: "图片",
          iconUrl: "/static/img/mypic0.jpg",
          switchJudge: {
            judge: true,
            msg: ""
          }
        },
        logo: {
          id: "logo",
          name: "LOGO",
          iconUrl: "/static/img/team-logo.png",
          switchJudge: {
            judge: true,
            msg: ""
          }
        },
        music: {
          id: "music",
          name: "音频",
          iconUrl: "/static/img/mybgsound0.jpg",
          switchJudge: {
            judge: true,
            msg: ""
          }
        },
        // musicType: {
        //   id: "musicType",
        //   name: "录音",
        //   iconUrl: "/static/img/mysound0.jpg",
        //   switchJudge: {
        //     judge: true,
        //     msg: ""
        //   }
        // },
        video: {
          id: "video",
          name: "视频",
          iconUrl: "/static/img/myvideo0.jpg",
          switchJudge: {
            judge: true,
            msg: ""
          }
        }
        // gif: {
        //   id: 'gif',
        //   name: 'GIF图',
        //   iconUrl: '/static/img/mygif0.jpg',
        //   switchJudge: {
        //     judge: true,
        //     msg: ''
        //   }
        // }
      },
      dataArray: [], // 数据数组
      scollTop: {
        // 控制滚动条的数据
        default: 0, // 默认添加的高度
        Incremental: 140, // 单个分类的高度
        material: 75 // 单个元素的高度
      },
      dataSet: {
        // 请求数据对象
        pIndex: 0,
        type: 3,
        sOfPage: 24,
        fPage: 24,
        style: null
      },
      myScenesData: {}, // 保存场景的截图，判断当前场景的截图是否存在，不存在则替换
      soundData: {
        toolSound: "",
        sceneSound: "",
        testSound: "",
        playType: false,
        sceneSoundData: true
      },
      switchDataType: 0,
      addTeamTemplateing: false
    };
  },
  watch: {
    dataMsg: function (val, oldval) {
      // 打开盒子操作
      if (this.dataMsg === this.boxName) {
      } else {
        this.testListenSound(false);
      }
    },
    slideState: function (val, oldval) {
      // 打开盒子操作
      if (!this.slideState) {
        this.testListenSound(false);
      }
    },
    "SelectScenes_Msg.sound": function (val, oldval) {
      // 加载分组音乐
      if (this.SelectScenes_Msg.sound && this.SelectScenes_Msg.sound.url) {
        this.soundData.sceneSound = this.SelectScenes_Msg.toJson().sound[0];
      } else {
        this.soundData.sceneSound = "";
      }
    },
    SelectScenes_Msg: function (val, oldval) {
      // 加载分组音乐
      if (this.SelectScenes_Msg.sound && this.SelectScenes_Msg.sound.url) {
        this.soundData.sceneSound = this.SelectScenes_Msg.toJson().sound[0];
      } else {
        this.soundData.sceneSound = "";
      }
    },
    "TOOL.sound": function () {
      // 监控bgm改变
      if (this.TOOL.sound && this.TOOL.sound.url) {
        let TOOLData = this.TOOL.toJson();
        this.soundData.toolSound = TOOLData.sound[0];
      } else {
        this.soundData.toolSound = "";
      }
    },
    SpriteOperation: {
      handler (val) {
        if (val == "add") {
          this.switchBgSpritesFS(0);
        } else {
          this.switchBgSpritesFS(1);
        }
      }
    },
    BgOperation: {
      handler (val) {
        if (val == "add") {
          this.switchBgSpritesFS(0);
        } else {
          this.switchBgSpritesFS(2);
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      "TopNav_Size",
      "Window_Size",
      "SelectScenes_Msg",
      "UserTeamInfo"
    ]),
    ...mapGetters({
      musicArr: 'addSoundtrack/getMusicArr',
      dubbingArr: 'addSoundtrack/getDubbingArr'
    })
  },
  mounted () {
    this.$bus.on("modifyUserItem_del_vue", data => {
      // 取消收藏
      if (data.type && data.boxName == this.boxName) {
        this.dataArray[data.type].pIndex = 1;
        this.dataArray[data.type].data = [];
        this.loading = true;
        this.getUserData(data.type);

        this.$message({
          showClose: true,
          message: "已删除作品",
          type: "success"
        });
      }
    });
  },
  methods: {
    thisGetUserData (id) {
      if (!this.dataArray[id].data.length) {
        let cate = this.cateOptions[this.selectedCateIndex] || {};
        this.getUserData(id, cate.id);
      }
    },
    userExtensionsGetData (item) {
      if (!this.dataArray[item.id].data.length) {
        this.getUserExtensions(item.id);
      }
    },
    modifyPopups (data, boxName, el) {
      // 修改title，tag
      if (boxName === "musicType") {
        data.musicType = 1;
      }
      this.$bus.emit("FeaturesPop_vue", {
        name: "modifyUserItem",
        typeName: "bg",
        posx: this.TopNav_Size.width - 445,
        posy: el.clientY,
        data: data,
        type: 2,
        boxName: boxName,
        typeName: this.boxName
      });
      this.$bus.emit("modifyUserItem_vue", {
        posx: this.TopNav_Size.width - 445,
        posy: el.clientY,
        data: data,
        boxName: boxName,
        typeName: this.boxName
      });
    },
    setToolSound (music) {
      // 设置全局音乐
      // 防止重复设置
      if (this.TOOL.sound && this.TOOL.sound.resourceId === music.id) return;

      // 添加背景音乐
      this.TOOL.setSound(
        {
          // 添加全局bgm
          resourceId: music.id, // 资源id 用于查询资源的信息，下同
          title: music.title,
          fileType: music.fileType,
          url: this.$handleAssetsUrl(music.url), // 资源路径
          isLoop: true, // 是否循环
          volume: 50, // 音量0-100
          subtitle: null, // 字幕（预留字段）
          endTime: 0,
          startTime: 0
        },
        true
      );
      this.showVolume();
    },
    setSceneSound (music) {
      // 设置当前场景音乐
      // 防止重复设置
      if (
        this.soundData.sceneSound &&
        this.soundData.sceneSound.resourceId === music.id
      )
        return;

      this.TOOL.selectedScenes.setSound(
        {
          resourceId: music.id,
          id: music.id,
          url: this.$handleAssetsUrl(music.url),
          startTime: 0,
          fileType: music.fileType,
          title: music.title
        },
        true
      );
    },
    setSceneSound_ (music) {
      // 设置当前场景音乐
      this.SelectScenes_Msg.setSound(
        {
          resourceId: music.id,
          id: music.id,
          url: this.$handleAssetsUrl(music.url),
          startTime: 0,
          fileType: music.fileType,
          title: music.title
        },
        false
      );

      // this.TOOL.soundRecordBackup[this.TOOL.selectedScenes.index] = this.TOOL.selectedScenes.getSound();
      let arr = this.TOOL.sprites.map(s => s.getSound());
      this.TOOL.setSoundRecord(arr, "scene", true);
      this.showVolume();
    },
    setSoundRecord (music) {
      // 设置全局录音
      this.TOOL.setSoundRecord(
        {
          resourceId: music.id,
          id: music.id,
          url: this.$handleAssetsUrl(music.url),
          startTime: 0,
          fileType: music.fileType,
          title: music.title
        },
        "global",
        true
      );
      this.showVolume();
    },
    testListenSound (data) {
      // 音乐播放控制
      let caseType = 0;
      if (this.soundData.testSound && this.soundData.testSound.id === data.id) {
        caseType = 1;
      }
      if (!data) {
        caseType = 2;
      }
      switch (caseType) {
        case 0:
          this.soundData.testSound = "";
          this.soundData.testSound = {
            url: data.url,
            id: data.id
          };
          let timeoutid = setTimeout(() => {
            this.soundData.testSound.dom = this.$refs.userExtensionsTestSound;
            this.soundData.testSound.dom.play();
            this.soundData.testSound.dom.addEventListener("timeupdate", () => {
              if (
                this.soundData.testSound.dom.currentTime + 0.05 >=
                this.soundData.testSound.dom.duration
              ) {
                this.soundData.playType = false;
              }
            });
            this.soundData.playType = true;
          }, 200);
          break;
        case 1:
          if (this.soundData.testSound.dom.paused) {
            this.soundData.testSound.dom.play();
            this.soundData.playType = true;
          } else {
            this.soundData.testSound.dom.pause();
            this.soundData.playType = false;
          }
          break;
        case 2:
          if (this.soundData.testSound) {
            this.soundData.testSound.dom.pause();
            this.soundData.playType = false;
          }
          break;
      }
    },
    imgErroeFs (e, data) {
      if (data.url) {
        let frequency = e.target.getAttribute("load-frequency");
        if (!frequency) {
          e.target.setAttribute("load-frequency", "0");
          frequency = 0;
        }
        if (frequency < 30) {
          let timeoutid = setTimeout(() => {
            e.target.setAttribute("load-frequency", frequency - 0 + 1);
            e.srcElement.src = e.srcElement.src;
            clearTimeout(timeoutid);
          }, 2000);
        }
      }
    },
    sceneErroeFs (e) {
      if (this.myScenesData.bg && e && e.srcElement && e.srcElement.src) {
        e.srcElement.src = this.$handleAssetsUrl(this.myScenesData.bg);
      }
    },
    resultFormat (duration) {
      if (duration <= 0) return "00:00";
      if (!duration) return "--:--";
      var min = ~~(duration / 60);
      min = (min + "").length === 1 ? "0" + min : min;
      var sec = Math.round(duration % 60);
      sec = (sec + "").length === 1 ? "0" + sec : sec;
      min = min || "00";
      sec = sec || "00";
      return min + ":" + sec;
    },
    showVolume () {
      this.$bus.emit("FeaturesPop_vue", {
        name: "volume_adjust",
        posx: 0,
        posy: 0,
        type: 1
      });
    },

    switchBgSpritesFS (data) {
      let msgData = "";

      this.getUserData("pic");
      this.dataBoxAction("pic");
      switch (data) {
        case 0:
          this.switchDataType = 0;
          this.personalCategory.pic.switchJudge.judge = true;
          this.personalCategory.video.switchJudge.judge = true;
          this.personalCategory.music.switchJudge.judge = true;
          //this.personalCategory.musicType.switchJudge.judge = true;
          break;
        case 1: // 元素切换
          this.switchDataType = 1;
          msgData = "请选择图片、GIF或视频以替换素材";
          this.personalCategory.pic.switchJudge.judge = true;
          this.personalCategory.video.switchJudge.judge = true;
          this.personalCategory.music.switchJudge.judge = false;
          //this.personalCategory.musicType.switchJudge.judge = false;
          break;
        case 2: // 背景切换
          this.switchDataType = 2;
          msgData = "请选择图片或视频以替换背景";
          this.personalCategory.pic.switchJudge.judge = true;
          this.personalCategory.video.switchJudge.judge = true;
          this.personalCategory.music.switchJudge.judge = false;
          //this.personalCategory.musicType.switchJudge.judge = false;
          break;
      }
      this.personalCategory.video.switchJudge.msg = msgData;
      this.personalCategory.pic.switchJudge.msg = msgData;
      this.personalCategory.music.switchJudge.msg = msgData;
      //this.personalCategory.musicType.switchJudge.msg = msgData;
    },

    switchDataBoxAction (data) {
      if (!this.personalCategory[data].switchJudge.judge) {
      } else {
        this.dataBoxAction(data);
      }
    },

    picItemClickFS (data, type) {
      let itemType = type || "pic";

      switch (this.switchDataType) {
        case 0:
        case 1:
          switch (itemType) {
            case "video":
              this.addVideoSprite(data, "sprite");
              break;
            case "pic":
              this.slidAddSprites(data);
              break;
            case "logo":
              this.slidAddSprites({
                fileType: data.fileType,
                resourceId: data.id,
                url: data.logoUrl
              });
              break;
          }
          break;
        case 2:
          switch (itemType) {
            case "video":
              this.addVideoSprite(data, "bg");
              this.materialPushAnalysis({ type: "imgSettingBg" });
              break;
            case "pic":
              this.settingScenesBg(data);
              this.materialPushAnalysis({ type: "imgSettingBg" });
              break;
          }
          break;
      }
    },
    addVideoSprite (data, type) {
      if (this.SpriteOperation === "swap") {
        this.slidAddSprites(data);
        return;
      }
      if (this.BgOperation === "swap") {
        this.settingScenesBg(data);
        return;
      }
      this.$bus.emit("confirmAddVideo", {
        type: type, // 'bg' 'sprite'
        data: data
      });
    },

    addTeamTemplateUserConfirm (data) {
      this.$modal.show("MessageDialog", {
        title: "",
        content:
          "确认添加团队模板后将会保存现有项目，并在当前页加载新的模板数据,请确认操作?",
        btns: ["Ok", "Cancel"],
        resultHandler: type => {
          if (type == "Ok") {
            //1.先保存当前项目
            //2.再添加团队模板
            this.$store.commit("save_TopnavMsg", {
              isShowSavingMask: true,
              savingMaskText: "正在保存当前项目"
            });
            this.$bus.once("saveWorks.completed", () => {
              this.addTeamTemplate(data.id);
            });
            this.$bus.emit("save");
          }
        }
      });
    },
    addTeamTemplate (id) {
      this.$store.commit("save_TopnavMsg", {
        isShowSavingMask: true,
        savingMaskText: "正在打开团队模板"
      });
      if (this.addTeamTemplateing) {
        return;
      }
      this.addTeamTemplateing = true;
      let _this = this;
      this.$http
        .post("/api/user/account/cooperation/draft", {
          id: id,
          isCopy: 1
        })
        .then(res => {
          if (res.data.code == 200 && res.data.data.id) {
            let { origin, pathname } = window.location;
            //加故意time参数，放置浏览器不刷新
            window.location.assign(
              origin +
              pathname +
              "?time=" +
              new Date().getTime() +
              "#/" +
              res.data.data.id
            );
          }
          this.addTeamTemplateing = false;
        });
      //
    }
  },
  components: {
    Search,
    DropDownMenu,
    NewSoundFeature
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.team {
  width: 270px;
  min-height: 200px;
  border-radius: 8px;
  position: relative;
  top: -20px;

  .messageBar {
    top: 0px;
    left: 0px;
    z-index: 12;
    height: 35px;
    width: 270px;
    border-radius: 3px;
    text-indent: 0px;
    background-color: rgba(87, 120, 251, 0.65);
    text-align: left;
    line-height: 35px;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      background-color: rgba(87, 120, 251, 0.8);
    }
  }

  .add-bg {
    width: 100%;
    height: auto;
    position: relative;
    cursor: pointer;
    div {
      height: 35px;
      margin: 0 auto;
      margin-top: 20px;
      text-align: center;
      line-height: 35px;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        color: #909399;
        .uploadResource {
          background: url('../../../../static/svg/upload00.svg') no-repeat
            center;
        }
        a {
          color: #909399;
        }
      }

      .uploadResource {
        display: inline-block;
        width: 15px;
        height: 15px;
        margin-bottom: -2px;
        background: url('../../../../static/svg/upload01.svg') no-repeat center;
      }
      a {
        color: #000;
        text-decoration: none;
      }
    }
    .audioScenesMsg {
      height: 35px;
      width: 250px;
      margin: 0 auto;
      margin-top: 10px;
      border-radius: 3px;
      text-indent: 0px;

      &:hover {
        background-color: #a3a6cd;
      }
    }
  }
  section {
    width: 270px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #474261;
    right: 0;
    margin-bottom: 5px;
    background: #fff;
    img {
      width: 270px;
      height: 90px;
      background-color: #87307e;
      border-radius: 8px;
      margin-bottom: 9px;
      cursor: pointer;
    }
    .expand-line {
      width: 270px;
      height: 16px;
      background-color: #ccc;
    }
  }

  .switchData {
    width: 270px;
    height: 90px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #fff;
    right: 0;
    margin-bottom: 5px;
    background: rgba(0, 0, 0, 0.75);
    border-radius: 8px;
  }
  .fix-switchData {
    position: absolute;
    top: 22px !important;
    left: 0 !important;
    cursor: not-allowed;
  }
  .data-body {
    padding: 22px 0 44px;
    height: 140px;
    overflow: hidden;
    position: relative;

    .body-list {
      border-top: 2px solid #d6d3d3;
      position: relative;
      min-height: 88px;
      // display: flex;
      // flex-wrap: wrap;
      // justify-content: space-between;
      padding-top: 5px;
      text-align: left;

      &:before {
        content: '';
        position: absolute;
        top: -6px;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 10px;
        height: 10px;
        background: #fff;
        transform: rotate(135deg);
        border-top: 2px solid #d6d3d3;
        border-right: 2px solid #d6d3d3;
      }

      .item {
        display: inline-block;
        &:nth-of-type(even) {
          margin-left: 10px;
        }
        &:nth-of-type(odd) {
          margin-left: 0;
        }

        width: 130px;
        height: 75px;
        margin-top: 15px;
        border-radius: 3px;
        background: #fff;
        position: relative;
        border: 2px solid #eaeaf5;
        overflow: hidden;

        &:hover {
          border-color: #5778fb;
        }

        > img {
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          z-index: 0;
          margin: auto;
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
        }
        .maskItem {
          position: absolute;
          bottom: 0px;
          left: 0px;
          width: 100%;
          height: 100%;
          z-index: 0;
          .videoMsg {
            width: 100%;
            height: 100%;
            opacity: 0;
            background: #fff;
            color: #fff;
            transition: all 0.3s;
            padding-top: 18px;

            &:hover {
              background: rgba(0, 0, 0, 0.4);
              opacity: 1;
            }
          }
        }

        .modify,
        .label {
          position: absolute;
          bottom: 0px;
          left: 0px;
          z-index: 10;
          width: 30px;
          height: 18px;
          background: #d83d60;
          color: #fff;
          border-radius: 5px;
          line-height: 18px;
        }
        .modify {
          width: 50px;
          height: 50px;
          opacity: 0;
          z-index: 8;
          cursor: pointer;
          transition: all 0.3s;
        }
        .modifyScene {
          background: url('../../../../static/svg/closecollection.svg')
            no-repeat center;
          background-color: rgba(0, 0, 0, 0.6);
          background-size: 25px auto;
          &:hover {
            background: url('../../../../static/svg/closecollection.svg')
              no-repeat center;
            background-color: rgba(0, 0, 0, 0.8);
            background-size: 25px auto;
          }
        }
        .modifyBg {
          background: url('../../../../static/svg/settingbackground.svg')
            no-repeat center;
          background-color: rgba(0, 0, 0, 0.6);
          background-size: 20px auto;
          &:hover {
            background: url('../../../../static/svg/settingbackground.svg')
              no-repeat center;
            background-color: rgba(0, 0, 0, 0.8);
            background-size: 20px auto;
          }
        }
        .modifyImg {
          background-image: url('../../../../static/svg/edit-display-white.svg');
          background-size: 20px 18px;
          background-repeat: no-repeat;
          background-position: center;
        }
        &:hover {
          .modify {
            opacity: 1;
          }
        }
      }
      .haveCateOptions {
        &:nth-of-type(odd) {
          margin-left: 10px;
        }
        &:nth-of-type(even) {
          margin-left: 0;
        }
      }
      .label {
        position: absolute;
        bottom: 5px;
        right: 5px;
        width: 30px;
        height: 18px;
        background: #d83d60;
        color: #fff;
        border-radius: 5px;
        line-height: 18px;
        text-indent: 0px;
        text-align: center;
      }
      .label {
        bottom: 4px;
        right: 50px;
      }
      .itemAudio {
        display: flex;
        flex-direction: row;
        width: 270px;
        height: 60px;
        margin-top: 3px;
        border-radius: 3px;
        background-color: #fafafd;
        border-radius: 4px;
        border: solid 1px #dbdff0;
        position: relative;
        align-items: center;
        overflow: hidden;

        &:hover {
          background-color: #dbdff0;
        }
        .play,
        .stop {
          display: block;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          cursor: pointer;
        }
        .play {
          background: url('../../../../static/svg/materialPane/music/play.svg')
            no-repeat center;
        }
        .stop {
          background: url('../../../../static/svg/materialPane/music/pause.svg')
            no-repeat center;
        }

        .playGrid {
          width: 52px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .detailGrid {
          position: relative;
          flex-grow: 1;
          //background-color: red;
          height: 100%;
          width: 137px;
          .name {
            position: absolute;
            display: block;
            color: #474261;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-align: left;
            max-width: 130px;
            top: 13px;
          }
          .duration {
            position: absolute;
            top: 35px;
            left: 0px;
            color: #a5a7c6;
            text-align: left;
            font-size: 12px;
          }
        }
        .selectedGrid {
          position: relative;
          width: 34px;
          height: 100%;
          .select,
          .select-active {
            display: inline-flex;
            width: 24px;
            height: 24px;
            cursor: pointer;
          }

          .select {
            margin: 0px;
            background: url('../../../../static/svg/select.svg') no-repeat
              center;
            &:hover {
              background: url('../../../../static/svg/select-active.svg')
                no-repeat center;
            }
          }
          .select-active {
            background: url('../../../../static/svg/select-active.svg')
              no-repeat center;
          }
        }
      }
    }
    .fix-section-top {
      // position: fixed;
      top: 130px;
      right: 82px;
      z-index: 10;
      transition: all 0.3s;
    }
  }
}
.set-sound-content {
  width: 150px;
  margin-left: -13px;

  div {
    padding: 5px;
    text-align: center;
    cursor: pointer;

    &:last-child {
      margin-bottom: 0;
    }

    &:hover {
      background-color: #d9dde9;
    }
  }
}
.menu-wrapper {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  padding-top: 10px;
}

.info-trigger {
  border: 2px #333 solid;
  border-radius: 50%;
  display: inline-block;
  color: #333;
  width: 20px;
  height: 20px;
  font-weight: bold;
  transform: scale(0.6) translatey(5px);
}
</style>



// WEBPACK FOOTER //
// src/components/rightnav/slide/team.vue